import ajaxRequest from './ajax'
import qs from "qs"

//获取report的内容
export const get_report_list_by_role = () => {
    return ajaxRequest.get("report/get_report_list_by_role")
}  


// WEBPACK FOOTER //
// ./src/api/report.js